module.exports = __webpack_public_path__ + "static/media/sponsor-athletic-greens.73cbc968.png";